<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp"> </p>
<p class="ctbm"><span epub:type="pagebreak" id="pg_VII" title="VII"><span class="ePub-SC">CONTENTS</span></span></p>
<p class="toc">  <a href="#/xhtml/chapter1">1. Making Law Intelligible in Comparative Context</a></p>
<p class="tocau"><span class="ePub-I">Brian P. Owensby and Richard J. Ross</span></p>
<p class="tocpt"><span href="#/xhtml/part1" title="Link target outside of Sample"><span class="ePub-SC">PART I. MIS-DIALOGUES, CODE SWITCHING, AND MIXING LANGUAGES OF LAW</span></span></p>
<p class="toc">  <span href="#/xhtml/chapter2" title="Link target outside of Sample">2. Dialoguing with Barbarians: What Natives Said and How Europeans Responded in Late-Seventeenth- and Eighteenth-Century Portuguese America</span></p>
<p class="tocau"><span class="ePub-I">Tamar Herzog</span></p>
<p class="toc">  <span href="#/xhtml/chapter3" title="Link target outside of Sample">3. Defending and Defrauding the Indians: John Wompas, Legal Hybridity, and the Sale of Indian Land</span></p>
<p class="tocau"><span class="ePub-I">Jenny Hale Pulsipher</span></p>
<p class="toc">  <span href="#/xhtml/chapter4" title="Link target outside of Sample">4. “Since We Came out of This Ground”: Iroquois Legal Arguments at the Treaty of Lancaster</span></p>
<p class="tocau"><span class="ePub-I">Craig Yirush</span></p>
<p class="toc">  <span href="#/xhtml/chapter5" title="Link target outside of Sample">5. “<span class="ePub-I">Ynuvaciones malas e rreprouadas</span>”: Seeking Justice in Early Colonial Pueblos de Indios</span></p>
<p class="tocau"><span class="ePub-I">Karen B. Graubart</span></p>
<p class="tocpt"><span href="#/xhtml/part2" title="Link target outside of Sample"><span class="ePub-SC">PART II. AT THE BOUNDARIES OF DIFFERING CONCEPTIONS OF JUSTICE</span></span></p>
<p class="toc">  <span href="#/xhtml/chapter6" title="Link target outside of Sample">6. “Darling Indians” and “Natural Lords”: Virginia’s Tributary Regime and Florida’s Republic of Indians in the Seventeenth Century</span></p>
<p class="tocau"><span class="ePub-I">Bradley Dixon</span></p>
<p class="toc">  <span href="#/xhtml/chapter7" title="Link target outside of Sample">7. Covering Blood and Graves: Murder and Law on Imperial Margins</span></p>
<p class="tocau"><span class="ePub-I">Nancy O. Gallman and Alan Taylor</span></p>
<p class="toc">  <span epub:type="pagebreak" id="pg_viii" title="viii"><span href="#/xhtml/chapter8" title="Link target outside of Sample">8. “Sovereignty Has Lost Its Rights”: Liberal Experiments and Indigenous Citizenship in New Granada, 1810–1819</span></span></p>
<p class="tocau"><span class="ePub-I">Marcela Echeverri</span></p>
<p class="tocpt"><span href="#/xhtml/part3" title="Link target outside of Sample"><span class="ePub-SC">PART III. CONCLUDING PERSPECTIVES</span></span></p>
<p class="toc">  <span href="#/xhtml/chapter9" title="Link target outside of Sample">9. In Defense of Ignorance: Frameworks for Legal Politics in the Atlantic World</span></p>
<p class="tocau"><span class="ePub-I">Lauren Benton</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample">10. Intelligibility or Incommensurability?</span></p>
<p class="tocau"><span class="ePub-I">Daniel K. Richter</span></p>
<p class="tocbmf"><span href="#/xhtml/acknowledgments" title="Link target outside of Sample"><span class="ePub-I">Acknowledgments</span></span></p>
<p class="tocbm"><span href="#/xhtml/abouttheeditor" title="Link target outside of Sample"><span class="ePub-I">About the Editors</span></span></p>
<p class="tocbm"><span href="#/xhtml/contributors" title="Link target outside of Sample"><span class="ePub-I">About the Contributors</span></span></p>
<p class="tocbm"><span href="#/xhtml/index" title="Link target outside of Sample"><span class="ePub-I">Index</span></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4b6ad75e